import React from "react";

const sections = [
  {
    title: "The Shift Towards Digital-First Business Models ",
    content: `With increasing internet penetration and changing consumer behavior, businesses are rapidly shifting toward digital platforms. B2B buyers now conduct extensive online research before making purchasing decisions. Without a solid digital strategy, companies risk losing valuable leads to competitors who are more visible online. 
    
    At Growth Loom Digital, we help businesses build a strong digital footprint across search engines, social media, and high-performing platforms.`,
  },
  {
    title: "Access to Expertise and Advanced Tools",
    content: `Partnering with a digital marketing agency gives you access to a team of experts—SEO specialists, PPC professionals, content strategists, and web developers.

We use advanced tools for:

• Keyword research and competitor analysis  

• Campaign tracking and performance optimization  

• Marketing automation and lead management  

This ensures data-driven decisions and higher ROI for your business. `,
  },
  {
    title: "Improved Lead Generation and Conversions",
    content: `For B2B businesses, generating high-quality leads is the top priority. At Growth Loom Digital, we create targeted strategies that attract the right audience and convert them into paying customers.

Our core services include:

• Search Engine Optimization (SEO)  
• Google Ads & PPC Campaigns  
• Content Marketing  
• Email Marketing  

These strategies help increase traffic, engagement, and conversions.`,
  },
  {
    title: "Cost-Effective and Scalable Growth",
    content: `Building an in-house marketing team can be expensive. A digital marketing agency provides cost-effective and scalable solutions tailored to your business goals.

Whether you are a startup or an established brand, Growth Loom Digital offers flexible strategies that grow with your business.`,
  },

  {
    title: "Focus on Your Core Business",
    content: `Managing digital campaigns requires time and expertise. By partnering with Growth Loom Digital, you can focus on your core operations while we handle your marketing performance.

This improves efficiency and ensures your campaigns are continuously optimized.`,
  },

  {
    title: "Data-Driven Results That Matter",
    content: `In 2026, marketing success depends on data and performance metrics. We track everything—from website traffic to lead conversions—to deliver transparent and measurable results.

Our approach ensures:

• Better decision-making  
• Improved campaign performance  
• Higher return on investment (ROI)`,
  },

  {
    title: "Stay Ahead of the Competition",
    content: `The digital world is constantly evolving. Algorithms, trends, and technologies change rapidly. A professional digital marketing agency ensures your business stays ahead.

At Growth Loom Digital, we stay updated with the latest trends to keep your brand competitive and future-ready.`,
  },

  {
    title: "Conclusion: Your Growth Partner in 2026",
    content: `As we step into 2026, partnering with a digital marketing agency is no longer optional—it’s essential. From boosting visibility to generating quality leads and delivering measurable growth, the right agency can transform your business.

👉 Growth Loom Digital is your trusted partner in building a powerful online presence and achieving long-term business success.`,
  },
];

const WhyDigital = () => {
  return (
    <section className="w-full py-12 sm:py-16 px-4 sm:px-6 lg:px-16 bg-[#f5f7fb] mt-[10%]">
      <div className="max-w-5xl mx-auto">

        {/* HEADER */}
        <div className="text-center mb-12 sm:mb-16">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-4 leading-snug">
            Why Every Business Needs a{" "}
            <span className="text-[#f99728]">
              Digital Marketing Agency
            </span>{" "}
            in 2026
          </h1>

          {/* <p className="text-gray-600 text-sm sm:text-base max-w-2xl mx-auto">
            A structured approach to growth, visibility, and long-term success.
          </p> */}
        </div>

        {/* TIMELINE */}
        <div className="relative">

          {/* vertical line */}
          <div className="hidden sm:block absolute left-4 top-0 w-[2px] h-full bg-[#f99728]"></div>

          <div className="space-y-10">
            {sections.map((item, index) => (
              <div
                key={index}
                className="relative flex flex-col sm:flex-row items-start gap-4"
              >

                {/* NUMBER CIRCLE */}
                <div className="flex-shrink-0">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-full bg-[#f99728] text-white font-bold shadow-md">
                    {index + 1}
                  </div>
                </div>

                {/* CONTENT */}
                <div className="bg-white w-full p-4 sm:p-6 rounded-xl shadow-sm border hover:shadow-md transition">
                  <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2">
                    {item.title}
                  </h3>

                  {item.content.split("\n").map((line, i) =>
                    line.trim().startsWith("•") ? (
                      <li key={i} className="ml-5 list-disc text-gray-600 text-sm sm:text-base">
                        {line.replace("•", "").trim()}
                      </li>
                    ) : (
                      <p key={i} className="text-gray-600 mb-2 text-sm sm:text-base leading-relaxed">
                        {line}
                      </p>
                    )
                  )}
                </div>

              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        {/* <div className="text-center mt-14 sm:mt-16">
          <button className="bg-yellow-500 hover:bg-yellow-600 text-white px-6 sm:px-8 py-2.5 sm:py-3 rounded-lg shadow transition text-sm sm:text-base">
            Learn More →
          </button>
        </div> */}

      </div>
    </section>
  );
};

export default WhyDigital;